<template>
  <div>
    <KeywordPlannerAddKeywordForm
      :show="show && !errors.length"
      @error="handleError"
      @back="back"
      @hide="close"
    />

    <KeywordPlannerAddKeywordError
      :show="show && Boolean(errors.length)"
      :errors="errors"
      @hide="resetErrorsAndClose"
    />
  </div>
</template>

<script>
import KeywordPlannerAddKeywordForm from './KeywordPlannerAddKeywordForm';
import KeywordPlannerAddKeywordError from './KeywordPlannerAddKeywordError';

export default {
  name: 'KeywordPlannerAddKeyword',
  components: {
    KeywordPlannerAddKeywordForm,
    KeywordPlannerAddKeywordError,
  },
  props: {
    show: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      errors: [],
    };
  },
  methods: {
    handleError(errors) {
      this.errors = errors;
    },
    back() {
      this.$emit('back');
    },
    resetErrorsAndClose() {
      this.errors = [];

      this.close();
    },
    close() {
      this.$emit('hide');
    },
  },
};
</script>
